import { CompanyType } from '../../types/resources/CompanyType';
import { fetchWrapper } from '../fetchWrapper';

export const getCurrentCompany = async (signOut: () => void): Promise<{ company: CompanyType }> => {
  const response = await fetchWrapper('/company', { method: 'GET' }, signOut);

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  return response.json();
};
